import isSuccessReduxSelector from 'modules/redux/selectors/is-success'
import { TRAINING_AUTH_DOMAIN } from 'modules/training/modules/app-auth/constants'

function isSuccessAuthSelector () {
  return isSuccessReduxSelector(TRAINING_AUTH_DOMAIN)
}

export default isSuccessAuthSelector
